import { verifyCredentialStatus, isSignedDocument } from '@trustvc/w3c-vc';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
var W3CCredentialStatusCode = /* @__PURE__ */ ((W3CCredentialStatusCode2) => {
  W3CCredentialStatusCode2[W3CCredentialStatusCode2["SKIPPED"] = 0] = "SKIPPED";
  W3CCredentialStatusCode2[W3CCredentialStatusCode2["DOCUMENT_NOT_ISSUED"] = 1] = "DOCUMENT_NOT_ISSUED";
  W3CCredentialStatusCode2[W3CCredentialStatusCode2["DOCUMENT_REVOKED"] = 11] = "DOCUMENT_REVOKED";
  W3CCredentialStatusCode2[W3CCredentialStatusCode2["DOCUMENT_SUSPENDED"] = 12] = "DOCUMENT_SUSPENDED";
  W3CCredentialStatusCode2[W3CCredentialStatusCode2["DOCUMENT_REVOKED_AND_SUSPENDED"] = 101] = "DOCUMENT_REVOKED_AND_SUSPENDED";
  W3CCredentialStatusCode2[W3CCredentialStatusCode2["STATUS_LIST_NOT_FOUND"] = 404] = "STATUS_LIST_NOT_FOUND";
  W3CCredentialStatusCode2[W3CCredentialStatusCode2["INVALID_VALIDATION_METHOD"] = 8] = "INVALID_VALIDATION_METHOD";
  W3CCredentialStatusCode2[W3CCredentialStatusCode2["UNRECOGNIZED_DOCUMENT"] = 9] = "UNRECOGNIZED_DOCUMENT";
  W3CCredentialStatusCode2[W3CCredentialStatusCode2["SERVER_ERROR"] = 500] = "SERVER_ERROR";
  W3CCredentialStatusCode2[W3CCredentialStatusCode2["UNEXPECTED_ERROR"] = 4] = "UNEXPECTED_ERROR";
  W3CCredentialStatusCode2[W3CCredentialStatusCode2["INVALID_ARGUMENT"] = 6] = "INVALID_ARGUMENT";
  W3CCredentialStatusCode2[W3CCredentialStatusCode2["INVALID_ISSUERS"] = 7] = "INVALID_ISSUERS";
  return W3CCredentialStatusCode2;
})(W3CCredentialStatusCode || {});
const w3cCredentialStatus = {
  skip: /* @__PURE__ */ __name(async () => {
    return {
      type: "DOCUMENT_STATUS",
      name: "W3CCredentialStatus",
      reason: {
        code: 0 /* SKIPPED */,
        codeString: "SKIPPED",
        message: `Document does not have a valid credentialStatus or type.`
      },
      status: "SKIPPED"
    };
  }, "skip"),
  test: /* @__PURE__ */ __name((document) => {
    const doc = document;
    const credentialStatuses = Array.isArray(doc?.credentialStatus) ? doc?.credentialStatus : [doc?.credentialStatus];
    const test = /* @__PURE__ */ __name((credentialStatus) => ["BitstringStatusListEntry", "StatusList2021Entry"].includes(credentialStatus?.type), "test");
    if (isSignedDocument(document) && credentialStatuses.every(test)) {
      return true;
    } else {
      return false;
    }
  }, "test"),
  verify: /* @__PURE__ */ __name(async (document, verifierOptions) => {
    const doc = document;
    const credentialStatuses = Array.isArray(doc.credentialStatus) ? doc.credentialStatus : [doc.credentialStatus];
    const verificationResult = await Promise.all(
      credentialStatuses.map(
        (cs) => verifyCredentialStatus(cs, cs?.type, verifierOptions)
      )
    );
    const purposes = verificationResult.map((item) => item.purpose);
    const hasRevocation = purposes.includes("revocation");
    const hasSuspension = purposes.includes("suspension");
    const hasRevocationAndSuspension = hasRevocation && hasSuspension;
    if (verificationResult.some((r) => r.error)) {
      return {
        type: "DOCUMENT_STATUS",
        name: "W3CCredentialStatus",
        reason: {
          code: 4 /* UNEXPECTED_ERROR */,
          codeString: "ERROR",
          message: verificationResult.map((r) => r.error).join(", ")
        },
        data: verificationResult,
        status: "ERROR"
      };
    } else if (verificationResult.every((r) => r.status === false)) {
      return {
        type: "DOCUMENT_STATUS",
        name: "W3CCredentialStatus",
        data: verificationResult,
        status: "VALID"
      };
    } else {
      return {
        type: "DOCUMENT_STATUS",
        name: "W3CCredentialStatus",
        data: verificationResult,
        status: "INVALID",
        reason: {
          code: hasRevocationAndSuspension ? 101 /* DOCUMENT_REVOKED_AND_SUSPENDED */ : hasRevocation ? 11 /* DOCUMENT_REVOKED */ : 12 /* DOCUMENT_SUSPENDED */,
          codeString: hasRevocationAndSuspension ? "REVOKED_AND_SUSPENDED" : hasRevocation ? "REVOKED" : "SUSPENDED",
          message: hasRevocationAndSuspension ? "Document has been revoked and suspended." : hasRevocation ? "Document has been revoked." : "Document has been suspended."
        }
      };
    }
  }, "verify")
};

export { W3CCredentialStatusCode, w3cCredentialStatus };
